module.exports = __webpack_public_path__ + "img/termscondition-bg-mob.e9b08644.png";